export const environment = {
  production: true,
  buildId: '2816963143319341',
  configFile: 'config.json',
};
